import React, { FC } from "react";
import { Paragraph, ParagraphProps } from "theme-ui";

type MediumType = {
  bold?: boolean;
} & ParagraphProps;

export const ParagraphMedium: FC<MediumType> = ({
  bold,
  children,
  ...props
}: MediumType) => (
  <Paragraph
    variant="medium"
    {...props}
    sx={{ fontWeight: bold ? "bold" : "normal" }}
  >
    {children}
  </Paragraph>
);

ParagraphMedium.defaultProps = {
  bold: false,
};
